import { createFileRoute } from '@tanstack/react-router';

import { AutoImportSection } from '@/features/auto-import';
import { BackupPanel } from '@/features/backup';
import { ResetPanel } from '@/features/reset';
import { SettingsPage } from '@/features/settings';
import { ApiKeysSection } from '@/features/sources';
import { SyncPanel } from '@/features/sync';

/**
 * Settings, data sources, the default aircraft and backup are separate
 * features (`features/settings`, `features/sources`, `features/auto-import`,
 * `features/backup`) that never import each other — this route is where they
 * actually share a page.
 *
 * The default aircraft sits above the sources it depends on, not below:
 * picking the aeroplane you fly is the decision a pilot came here to make,
 * and which API answers for it is the detail underneath.
 *
 * Sync sits above Backup: a sync folder is a backup that keeps itself
 * current, and the manual archive is what a pilot without one falls back on.
 *
 * Reset is last, below Backup, so the control that saves the data is read
 * before the one that deletes it.
 */
function SettingsRoute() {
  return (
    <div className="mx-auto w-full max-w-2xl space-y-4">
      <SettingsPage />
      <AutoImportSection />
      <ApiKeysSection />
      <SyncPanel />
      <BackupPanel />
      {/* Set apart from Backup, so the control that deletes is not the next one down. */}
      <div className="pt-6">
        <ResetPanel />
      </div>
    </div>
  );
}

export const Route = createFileRoute('/settings')({
  component: SettingsRoute,
});
